// extracted by mini-css-extract-plugin
export var eyebrow = "_c4-3";
export var heroImage = "_c4-4";
export var main = "_c4-2";
export var modal = "_c4-0";
export var shell = "_c4-1";